import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
export const HomepageWidgets = Dynamic(async () => {
    const { HomepageWidgetsSurface } = await import('#pplx/frontend/apps/ask/widgets/home/surface/HomepageWidgetsSurface.js');
    return { default: HomepageWidgetsSurface };
});
//# sourceMappingURL=HomepageWidgets.js.map